/* =========================================================
   PLANTIVE BUNDLE BUILDER - JS (V6.7 - Scroll Lock Fix)
========================================================= */
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.pbb-section');

  function getFlavorColor(title) {
    const lower = title.toLowerCase();
    if(lower.includes('ช็อกโกแลต') || lower.includes('chocolate')) return '#4a3018';
    if(lower.includes('มอลต์') || lower.includes('malt')) return '#d4c4b7';
    if(lower.includes('เบอร์รี่') || lower.includes('berry')) return '#8b2846';
    return '#e2e2e2';
  }

  sections.forEach(section => {
    const openCards = section.querySelectorAll('.js-open-pbb-modal');
    const modal = section.parentElement.querySelector('.pbb-modal-overlay');
    if(!modal) return;

    const closeBtn = modal.querySelector('.pbb-modal-close');
    const slotsContainer = modal.querySelector('#pbb-m-slots');
    const summaryContainer = modal.querySelector('#pbb-m-summary-items');
    
    const btnAddCart = modal.querySelector('#pbb-m-add-cart');
    const btnBuyNow = modal.querySelector('#pbb-m-buy-now');
    
    const track = modal.querySelector('#pbb-m-main-track');
    const btnPrevImg = modal.querySelector('#pbb-m-prev');
    const btnNextImg = modal.querySelector('#pbb-m-next');

    const trustBadgesContainer = modal.querySelector('#pbb-m-trust-badges');

    const progStatusContainer = modal.querySelector('.pbb-m-prog-text');
    const progStatus = modal.querySelector('#pbb-m-prog-status');
    const progAlert = modal.querySelector('#pbb-m-prog-alert');
    const progFill = modal.querySelector('#pbb-m-prog-fill');
    
    const modalContent = modal.querySelector('.pbb-modal-content');
    
    let alertTimeout = null;
    let currentData = null;
    let selections = []; 
    let imagesArray = [];
    let currentImgIndex = 0;

    // 🌟 ฟังก์ชันปิด Modal และปลดล็อก Scroll พื้นหลัง 🌟
    function closeModal() {
      modal.classList.remove('is-active');
      document.body.classList.remove('pbb-modal-open');
    }

    function renderGallery() {
      if(imagesArray.length === 0) return;
      const imgWidth = track.clientWidth;
      track.scrollTo({ left: currentImgIndex * imgWidth, behavior: 'smooth' });
      btnPrevImg.style.display = currentImgIndex === 0 ? 'none' : 'flex';
      btnNextImg.style.display = currentImgIndex === imagesArray.length - 1 ? 'none' : 'flex';
    }

    btnPrevImg.addEventListener('click', () => { if(currentImgIndex > 0) { currentImgIndex--; renderGallery(); } });
    btnNextImg.addEventListener('click', () => { if(currentImgIndex < imagesArray.length - 1) { currentImgIndex++; renderGallery(); } });

    let scrollTimeout;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const newIndex = Math.round(track.scrollLeft / track.clientWidth);
        if(newIndex !== currentImgIndex && newIndex >= 0 && newIndex < imagesArray.length) {
          currentImgIndex = newIndex;
          renderGallery();
        }
      }, 50);
    });

    function updateSummary() {
      if(!currentData) return;

      let html = '';
      let completedSlots = 0;
      const totalSlots = currentData.slots.length;

      currentData.slots.forEach((slot, sIdx) => {
        const sel = selections[sIdx];
        if(sIdx > 0) html += `<div class="pbb-m-sum-plus">+</div>`;

        if(sel && sel.varId) {
          completedSlots++;
          const prod = slot.products.find(p => p.id == sel.prodId);
          const variant = prod.variants.find(v => v.id == sel.varId);
          const img = variant.image && variant.image !== 'null' ? variant.image : prod.image;
          const shortName = prod.title.split(' ')[0]; 

          html += `
            <div class="pbb-m-sum-item">
              <div class="pbb-m-sum-img"><img src="${img}"></div>
              <span class="pbb-m-sum-name">${shortName}</span>
            </div>`;
        } else {
          html += `
            <div class="pbb-m-sum-item">
              <div class="pbb-m-sum-img pbb-m-sum-empty"></div>
              <span class="pbb-m-sum-name" style="color:transparent">-</span>
            </div>`;
        }
      });

      if(currentData.gift) {
        if(totalSlots > 0) html += `<div class="pbb-m-sum-plus">+</div>`;
        html += `
          <div class="pbb-m-sum-item">
            <div class="pbb-m-sum-img"><img src="${currentData.gift.image}"></div>
            <span class="pbb-m-sum-name">${currentData.gift.title}</span>
            <span class="pbb-m-sum-gift">ฟรี!</span>
          </div>`;
      }

      summaryContainer.innerHTML = html;

      progStatus.innerText = `เลือกครบ ${completedSlots}/${totalSlots} กระปุก`;
      const percent = totalSlots > 0 ? (completedSlots / totalSlots) * 100 : 0;
      progFill.style.width = `${percent}%`;

      if(completedSlots === totalSlots) {
        progStatusContainer.classList.add('is-complete');
        btnAddCart.disabled = false;
        btnBuyNow.disabled = false;

        progAlert.classList.add('is-show');
        if(alertTimeout) clearTimeout(alertTimeout);
        alertTimeout = setTimeout(() => { progAlert.classList.remove('is-show'); }, 2500);

        setTimeout(() => {
           const btnOffset = btnBuyNow.offsetTop;
           modalContent.scrollTo({ top: btnOffset - 100, behavior: 'smooth' });
        }, 300);

      } else {
        progStatusContainer.classList.remove('is-complete');
        btnAddCart.disabled = true;
        btnBuyNow.disabled = true;

        progAlert.classList.remove('is-show');
        if(alertTimeout) clearTimeout(alertTimeout);
      }
    }

    function renderSlots() {
      if(!currentData) return;
      let html = '';

      currentData.slots.forEach((slot, sIdx) => {
        const sel = selections[sIdx];
        const isComplete = sel && sel.varId;

        html += `<div class="pbb-m-slot-row ${isComplete ? 'is-complete' : ''}">`;
        html += `  <div class="pbb-m-slot-header">`;
        html += `    <div class="pbb-m-slot-num">${sIdx + 1}</div>`;
        html += `    <div class="pbb-m-slot-label">${slot.label} <span style="font-weight:400; color:#86868b; font-size:12px; margin-left:6px;">${isComplete ? 'เลือกแล้ว' : 'เลือกสูตรและรสชาติ'}</span></div>`;
        html += `  </div>`;

        html += `  <div class="pbb-m-prod-list">`;
        slot.products.forEach(prod => {
          const isActive = sel && sel.prodId == prod.id;
          html += `<button class="pbb-m-prod-btn js-sel-prod ${isActive ? 'is-active' : ''}" data-slot="${sIdx}" data-prod="${prod.id}">${prod.title}</button>`;
        });
        html += `  </div>`;

        if (sel && sel.prodId) {
          const prod = slot.products.find(p => p.id == sel.prodId);
          html += `  <div class="pbb-m-flavor-list">`;
          prod.variants.forEach(v => {
            const isActive = sel.varId == v.id;
            const dotColor = getFlavorColor(v.title);
            html += `
              <label class="pbb-m-flavor-label ${isActive ? 'is-active' : ''} ${!v.available ? 'is-disabled' : ''}">
                <input type="radio" name="slot_${sIdx}" value="${v.id}" class="js-sel-flavor pbb-m-flavor-radio" data-slot="${sIdx}" ${isActive ? 'checked' : ''} ${!v.available ? 'disabled' : ''}>
                <span class="pbb-flavor-dot" style="background-color: ${dotColor}"></span>
                ${!v.available ? v.title + ' (หมด)' : v.title}
              </label>`;
          });
          html += `  </div>`;
        }
        html += `</div>`;
      });

      slotsContainer.innerHTML = html;

      slotsContainer.querySelectorAll('.js-sel-prod').forEach(btn => {
        btn.addEventListener('click', function() {
          const sIdx = parseInt(this.getAttribute('data-slot'));
          const pId = parseInt(this.getAttribute('data-prod'));
          selections[sIdx] = { prodId: pId, varId: null };
          renderSlots();
        });
      });

      slotsContainer.querySelectorAll('.js-sel-flavor').forEach(radio => {
        radio.addEventListener('change', function() {
          const sIdx = parseInt(this.getAttribute('data-slot'));
          const vId = parseInt(this.value);
          selections[sIdx].varId = vId;
          renderSlots();
          
          const nextSlotBtn = slotsContainer.querySelector(`button[data-slot="${sIdx + 1}"]`);
          if (nextSlotBtn) {
            setTimeout(() => {
               const offsetTop = nextSlotBtn.closest('.pbb-m-slot-row').offsetTop;
               modalContent.scrollTo({ top: offsetTop - 120, behavior: 'smooth' });
            }, 200);
          }
        });
      });

      updateSummary();
    }

    openCards.forEach(card => {
      card.addEventListener('click', function(e) {
        if (e.target.closest('.pbb-btn')) {} 
        e.preventDefault();

        currentData = JSON.parse(this.closest('.pbb-card').querySelector('.pbb-data-json').textContent);

        if(alertTimeout) clearTimeout(alertTimeout);
        progAlert.classList.remove('is-show');
        progFill.style.width = '0%';
        progStatusContainer.classList.remove('is-complete');
        modalContent.scrollTo(0,0);

        selections = currentData.slots.map(() => ({ prodId: null, varId: null }));
        imagesArray = currentData.images || [];
        currentImgIndex = 0;

        currentData.slots.forEach((slot, idx) => {
          if(slot.products.length === 1) { selections[idx].prodId = slot.products[0].id; }
        });

        modal.querySelector('#pbb-m-title').innerText = currentData.title;
        modal.querySelector('#pbb-m-desc').innerHTML = currentData.subtitle.replace(/\n/g, '<br>');
        modal.querySelector('#pbb-m-price').innerText = currentData.price + ' ฿';

        const compareWrap = modal.querySelector('#pbb-m-compare-wrap');
        const compareElem = modal.querySelector('#pbb-m-compare');
        const discountBadge = modal.querySelector('#pbb-m-discount-badge');

        if(currentData.compare && currentData.compare !== '') {
          compareElem.innerText = currentData.compare + ' ฿';
          
          const priceNum = parseInt(currentData.price.replace(/,/g, ''));
          const compareNum = parseInt(currentData.compare.replace(/,/g, ''));
          
          if (!isNaN(priceNum) && !isNaN(compareNum) && compareNum > priceNum) {
            const percent = Math.round(((compareNum - priceNum) / compareNum) * 100);
            discountBadge.innerText = `ลด ${percent}%`;
            discountBadge.style.display = 'inline-block';
          } else {
            discountBadge.style.display = 'none';
          }
          compareWrap.style.display = 'flex';
        } else { 
          compareWrap.style.display = 'none'; 
        }

        let badgeHtml = '';
        if(currentData.custom_text_1) badgeHtml += `<span><svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path></svg> ${currentData.custom_text_1}</span>`;
        if(currentData.custom_text_2) badgeHtml += `<span><svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg> ${currentData.custom_text_2}</span>`;
        if(currentData.custom_text_3) badgeHtml += `<span><svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg> ${currentData.custom_text_3}</span>`;
        trustBadgesContainer.innerHTML = badgeHtml;

        const giftBadge = modal.querySelector('#pbb-m-gift-badge');
        if(currentData.gift_text) {
          giftBadge.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg> ${currentData.gift_text}`;
          giftBadge.style.display = 'flex';
        } else { giftBadge.style.display = 'none'; }

        if(imagesArray.length > 0) {
          let trackHtml = '';
          imagesArray.forEach((imgUrl) => { trackHtml += `<img src="${imgUrl}">`; });
          track.innerHTML = trackHtml;
          track.style.scrollBehavior = 'auto'; track.scrollLeft = 0;
          setTimeout(() => { track.style.scrollBehavior = 'smooth'; }, 50);
          renderGallery();
        } else {
          track.innerHTML = ''; btnPrevImg.style.display = 'none'; btnNextImg.style.display = 'none';
        }

        renderSlots();
        
        // 🌟 เพิ่มคำสั่งเปิด Modal + ล็อก Scroll 🌟
        modal.classList.add('is-active');
        document.body.classList.add('pbb-modal-open');
      });
    });

    // 🌟 ดัก Event การปิด Modal ทุกช่องทาง 🌟
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if(e.target === modal) closeModal(); });

    function handleBundleCartAction(btnElement, isBuyNow) {
      const itemsToAdd = [];

      selections.forEach(sel => {
        if(sel && sel.varId) itemsToAdd.push({ id: sel.varId, quantity: 1 });
      });
      if(currentData.gift && currentData.gift.id) {
        itemsToAdd.push({ id: currentData.gift.id, quantity: 1 });
      }

      if(itemsToAdd.length === 0) return;

      btnElement.disabled = true;
      const originalHtml = btnElement.innerHTML;  
      btnElement.innerHTML = "กำลังโหลด...";

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
      .then(response => { if (!response.ok) throw response; return response.json(); })
      .then(data => {
        if(isBuyNow) {
          window.location.href = window.Shopify.routes.root + 'checkout';
        } else {
          // 🌟 ปิด Modal + ปลดล็อก Scroll 🌟
          closeModal();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
          btnElement.disabled = false;
          btnElement.innerHTML = originalHtml;
        }
      })
      .catch((error) => {
        alert("ไม่สามารถดำเนินการได้ เนื่องจากสินค้าบางรายการอาจหมดสต็อก (กรุณาเช็กสต็อกของแถมด้วยครับ)");
        btnElement.disabled = false; 
        btnElement.innerHTML = originalHtml; 
      });
    }

    btnAddCart.addEventListener('click', function() { handleBundleCartAction(this, false); });
    btnBuyNow.addEventListener('click', function() { handleBundleCartAction(this, true); });
  });
});